import { createFileRoute } from '@tanstack/react-router'
import { PasswordRecovery } from '@/components/password-recovery'

export const Route = createFileRoute('/forgot-password')({ component: () => <PasswordRecovery /> })
